'use client';

import { useEffect, useRef, useState } from 'react';
import { Box, Typography } from '@mui/material';

export default function Developer_Section() {
  const [headingWidth, setHeadingWidth] = useState('50vw');
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const handleScroll = () => {
      const sectionTop = section.offsetTop;
      const scrollY = window.scrollY;
      const relativeScroll = scrollY - sectionTop;

      if (relativeScroll < 5) setHeadingWidth('50vw');
      else if (relativeScroll >= 20 && relativeScroll < 70) setHeadingWidth('80vw');
      else if (relativeScroll > 90) setHeadingWidth('80vw');
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    const cards = Array.from(
      document.querySelectorAll('.card-reveal1, .card-reveal2, .card-reveal3')
    );

    cards.forEach((card) => card.classList.remove('show-card', 'hide-card'));

    const timeouts = new Map();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const card = entry.target;

          if (timeouts.has(card)) {
            clearTimeout(timeouts.get(card));
            timeouts.delete(card);
          }

          if (entry.isIntersecting) {
            card.classList.remove('hide-card');

            let delay = 250;
            if (card.classList.contains('card-reveal2')) delay = 500;
            if (card.classList.contains('card-reveal3')) delay = 600;

            const t = setTimeout(() => {
              card.classList.add('show-card');
              timeouts.delete(card);
            }, delay);

            timeouts.set(card, t);
          } else {
            card.classList.remove('show-card');
            card.classList.add('hide-card');
          }
        });
      },
      { threshold: 0.3, rootMargin: '0px 0px -50px 0px' }
    );

    cards.forEach((card) => observer.observe(card));

    return () => {
      window.removeEventListener('scroll', handleScroll);
      observer.disconnect();
      timeouts.forEach((t) => clearTimeout(t));
      timeouts.clear();
    };
  }, []);

  const cardsData = [
    { img: '/Upload.gif', text: 'Upload gamics', className: 'card-reveal1' },
    { img: '/PieChart.gif', text: 'View Stats &\nManagement', className: 'card-reveal2' },
    { img: '/Annocement.gif', text: 'Promote your\nGame', className: 'card-reveal3' },
  ];

  return (
    <Box
      id="developer-section"
      ref={sectionRef}
      sx={{
        position: 'relative',
        height: '150vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflowX: 'clip',
        width: '100%',
      }}
    >
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          height: '100vh',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          boxSizing: 'border-box',
        }}
      >
        {/* Heading */}
        <Box
          sx={{
            width: headingWidth,
            maxWidth: '95%',
            display: 'flex',
            justifyContent: 'center',
            transition: 'width 0.7s ease-out',
            flexShrink: 0,
          }}
        >
          <Typography
            variant="h2"
            sx={{
              color: 'white',
              fontFamily: 'Rammetto One',
              lineHeight: 1.2,
              fontSize: { xs: 32, sm: 36, md: 42, lg: 60, xl: 64 },
              textAlign: 'center',
            }}
          >
            DEVELOPERS & PUBLISHERS GUIDE
          </Typography>
        </Box>

        <Typography
          sx={{
            color: 'rgba(255,255,255,0.7)',
            mt: 3,
            letterSpacing: 1,
            textTransform: 'uppercase',
            px: { xs: 2, sm: 4 },
            fontSize: { xs: 16, sm: 16, md: 20, lg: 22, xl: 24 },
            textAlign: 'center',
            fontFamily: 'Poppins, sans-serif',
            maxWidth: '900px',
            boxSizing: 'border-box',
          }}
        >
          Overview for devs & publishers about their benefits and methods.
        </Typography>

        {/* Cards Area */}
        <Box
          sx={{
            mt: { xs: 6, sm: 8, md: 12 },
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            px: { xs: 1.5, sm: 2.5, md: 3 },
            boxSizing: 'border-box',
          }}
        >
          <Box
            sx={{
              width: '100%',
              maxWidth: 'min(1050px, 92vw)',
              minWidth: 0,
              boxSizing: 'border-box',
              display: 'grid',

              // Mobile: 1 | Tablet+Desktop: 3 (same layout)
              gridTemplateColumns: {
                xs: '1fr',
                sm: 'repeat(3, minmax(0, 1fr))',
              },

              gap: { xs: '12px', sm: '18px', lg: '22px' },
              justifyItems: 'center',
              alignItems: 'stretch',
            }}
          >
            {cardsData.map(({ img, text, className }, idx) => (
              <Box
                key={idx}
                className={className}
                sx={{
                  width: { xs: '90%', sm: '100%' },
                  maxWidth: 320,
                  minWidth: 0,
                  position: 'relative',
                  boxSizing: 'border-box',
                  m: 0,

                  display: 'flex',

                  // ✅ FIX: Tablet same as Desktop
                  flexDirection: { xs: 'row', sm: 'column' },

                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 2,

                  px: { xs: 2, sm: 2 },
                  py: { xs: 2.2, sm: 2.4, md: 2.6, lg: 3.0 },
                  minHeight: { xs: 'auto', sm: 280, lg: 330 },

                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  backgroundColor: 'rgba(255,255,255,0.08)',
                  willChange: 'transform, opacity',

                  opacity: 0,
                  transform: 'translateY(50px)',

                  '&.show-card': {
                    opacity: 1,
                    transform: 'translateY(0)',
                    transition: 'transform 0.7s ease-out, opacity 0.7s ease-out',
                  },

                  '&.hide-card': {
                    opacity: 0,
                    transform: 'translateY(30px) scale(0.98)',
                    transition: 'transform 0.45s ease-in, opacity 0.45s ease-in',
                  },
                }}
              >
                <Box
                  component="img"
                  src={img}
                  alt={text}
                  sx={{
                    width: { xs: 128, sm: 150, md: 190, lg: 220 },
                    maxWidth: '100%',
                    height: 'auto',
                    flexShrink: 0,
                    display: 'block',
                  }}
                />

                <Typography
                  sx={{
                    color: 'white',
                    fontFamily: 'Poppins, sans-serif',
                    textTransform: 'uppercase',
                    fontSize: { xs: '1.05rem', sm: '1.05rem', md: '1.12rem' },

                    // ✅ FIX: Tablet same as desktop alignment
                    textAlign: { xs: 'left', sm: 'center' },

                    lineHeight: 1.2,
                    whiteSpace: 'pre-line',
                    minHeight: '2.4em',
                    maxWidth: '100%',
                    overflowWrap: 'anywhere',
                  }}
                >
                  {text}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
